import { render, staticRenderFns } from "./CalendarSidePanel.vue?vue&type=template&id=a1200864&scoped=true"
import script from "./CalendarSidePanel.vue?vue&type=script&lang=js"
export * from "./CalendarSidePanel.vue?vue&type=script&lang=js"
import style0 from "./CalendarSidePanel.vue?vue&type=style&index=0&id=a1200864&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1200864",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1200864')) {
      api.createRecord('a1200864', component.options)
    } else {
      api.reload('a1200864', component.options)
    }
    module.hot.accept("./CalendarSidePanel.vue?vue&type=template&id=a1200864&scoped=true", function () {
      api.rerender('a1200864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Calendar/CalendarSidePanel.vue"
export default component.exports